<template>
  <v-dialog v-model="dialog" max-width="750" persistent transition="dialog-bottom-transition" scrollable>
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar flat dark color="secondary">
          <v-toolbar-title>Verval Berita Acara</v-toolbar-title>
          <v-spacer />
          <v-btn right icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text class="pb-0 black--text my-5">
        <v-row class="my-2">
          <v-col cols="12" md="8">
            <v-list-item class="px-0">
              <v-list-item-content class="py-0 px-1">
                <h3>
                  Dokumen Berita Acara Kepala Sekolah yang Lolos
                </h3>
                <div class="body-2">
                  Merupakan file dokumen resmi yang telah diunggah oleh pihak daerah yang berwenang
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="12" md="4">
            <v-list-item class="px-0">
              <v-list-item-content class="py-0">
                <v-list-item-title class="mt-5" />
                <v-list-item-subtitle class="link black--text body-2">
                  <v-btn depressed small dark color="blue" @click="onBa">
                    <v-icon left dark>
                      mdi-eye
                    </v-icon>
                    Lihat Dokumen
                  </v-btn>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
        <validation-observer ref="observer">
          <v-alert color="#FFF2E6" light>
            <div class="subtitle-1 font-weight-bold">Tanggapan Anda terkait laporan ini?</div>
            <div class="mt-3">
              <template v-for="(item, i) in M_STATUS_VERVAL">
                <v-btn
                  :key="i"
                  :outlined="form['k_tahap_peringkat_psp'] !== item"
                  :color="WARNA_STATUS[item] && WARNA_STATUS[item]['color']"
                  class="mx-md-1"
                  small
                  dark
                  depressed
                  @click="setOpsiPsp(item)"
                >
                  <v-icon left>{{ WARNA_STATUS[item] && WARNA_STATUS[item]['icon'] }}</v-icon>
                  {{ WARNA_STATUS[item] && WARNA_STATUS[item]['keterangan'] }}
                </v-btn>
              </template>
            </div>
          </v-alert>
          <div class="mt-4" v-if="form['k_tahap_peringkat_psp'] === 9">
            <validation-provider
              name="Catatan untuk Perbaikan Berkas Berita Acara"
              rules="maxChar: 500"
              mode="passive"
              v-slot="{ errors }"
            >
              <v-label class="subtitle-2">
                {{
                  WARNA_STATUS[Number(form['k_tahap_peringkat_psp'])] &&
                    WARNA_STATUS[Number(form['k_tahap_peringkat_psp'])]['catatanTeks']
                }}
              </v-label>
              <v-textarea
                class="mt-2"
                v-model="form['catatan']"
                hint="Maksimal 500 karakter"
                persistent-hint
                dense
                outlined
                :readonly="isPreview"
                :error-messages="errors"
              >
              </v-textarea>
            </validation-provider>
          </div>
        </validation-observer>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small text @click="close">
          Batal
        </v-btn>
        <v-btn class="ma-2" :disabled="!form['k_tahap_peringkat_psp']" color="success" elevation="1" @click="save">
          Simpan Data
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
export default {
  name: 'PopupNilai',
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
  },
  components: { ValidationObserver, ValidationProvider },
  data() {
    return {
      dialog: false,
      form: {
        k_tahap_peringkat_psp: '',
        catatan: '',
      },
      M_STATUS_VERVAL: [10, 9],
      WARNA_STATUS: {
        10: { color: 'success', icon: 'mdi-check', keterangan: 'Dokumen BA sudah sesuai', catatanTeks: 'Saran/Solusi' },
        9: {
          color: 'error',
          icon: 'mdi-close',
          keterangan: 'Dokumen BA belum sesuai, perlu ada perbaikan',
          catatanTeks: 'Catatan untuk Perbaikan Berkas Berita Acara',
        },
      },
    };
  },

  methods: {
    open() {
      this.dialog = true;
      this.form = {
        k_tahap_peringkat_psp: '',
        catatan: '',
      };
    },

    close() {
      this.dialog = false;
    },

    onBa() {
      window.open(this.detail && this.detail.url_ba);
    },

    setOpsiPsp(value) {
      if (this.isPreview) return;
      this.$set(this.form, 'k_tahap_peringkat_psp', value);
    },

    async save() {
      const valid = await this.$refs.observer.validate();
      if (valid) this.$emit('save', this.form);
    },
  },
};
</script>
